export default "__VITE_ASSET__d411b8f7__"